import React from "react";
// import Banner from "../../components/Banner";
// import Footer from "../../components/Footer";
// import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Select from "react-select";
import Spinner from "../../components/Spinner";
import { Modal } from "./../../components/Modal";
import {primaryLabelName, secondaryLabelName, uniqueIdentifier1Name} from "../../utils/helper"

const API = localStorage.getItem("assethost");

export default class FlagAsset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      msg: "",
      toastColor: "",
      assetId: "",
      assetType: "",
      assetBrand: "",
      assetModel: "",
      assetUniqueIdentier: "",

      flagType: "",
      date: "",
      houseBuildingNo: "",
      street: "",
      surburb: "",
      townCity: "",
      country: "",
      officialReport: "",

      assetFlagDropdownList: {},
      policeReportFile: null,
      errors: {},
      valid: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleFlag = this.handleFlag.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchDropdownLists = this.fetchDropdownLists.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    let assetId = urlParams.get("assetId");
    if (!assetId) {
      assetId = this.props.assetId;
    }
    const assetType = this.props.assetType;
    const assetBrand = this.props.assetBrand;
    const assetModel = this.props.assetModel;
    const assetUniqueIdentier = this.props.assetUniqueIdentier;

    if (assetId) {
      this.setState(
        {
          assetId,
          assetType,
          assetBrand,
          assetModel,
          assetUniqueIdentier,
        },
        this.fetchDropdownLists
      );
    } else {
      this.setState({
        msg: "No asset ID provided",
        toastColor: "danger",
      });
    }
  }

  fetchDropdownLists() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true });
    axios
      .get(API + `/asset/getflagdropdownlist`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          assetFlagDropdownList: response.data,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message || "Failed to load dropdown lists.",
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSelect(name, value) {
    this.setState({ [name]: value }, this.validate);
  }

  handleFileChange(e) {
    const { name } = e.target;
    const file = e.target.files ? e.target.files[0] : null;
    this.setState({ [name]: file }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (!s.flagType || !s.flagType.trim()) {
      errors.flagType = "Flag type is required";
      valid = false;
    }
    if (!s.date || !s.date.trim()) {
      errors.date = "Date is required";
      valid = false;
    }
    if (!s.houseBuildingNo || !s.houseBuildingNo.trim()) {
      errors.houseBuildingNo = "House/Building No is required";
      valid = false;
    }
    if (!s.surburb || !s.surburb.trim()) {
      errors.surburb = "Surburb is required";
      valid = false;
    }
    if (!s.townCity || s.townCity === 0) {
      errors.townCity = "Town/City is required";
      valid = false;
    }
    if (!s.country || !s.country.trim()) {
      errors.country = "Country is required";
      valid = false;
    }
    if (!s.officialReport || s.officialReport === "") {
      errors.officialReport = "Please specify if you made an official report";
      valid = false;
    }
    if (s.officialReport === "YES" && !s.policeReportFile) {
      errors.policeReportFile =
        "Police report file is required when report is made";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleFlag(e) {
    e.preventDefault();
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }

    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.location.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }

    this.setState({ loading: true, msg: "", toastColor: "" });

    let request = new FormData();
    request.append("assetId", this.state.assetId);
    request.append("assetStatus", this.state.flagType);
    request.append("flagDate", this.state.date);
    request.append("houseBuildingNoStreet", this.state.houseBuildingNo);
    request.append("street", this.state.street);
    request.append("surburb", this.state.surburb);
    request.append("townCityId", this.state.townCity);
    request.append("country", this.state.country);
    request.append("officialReport", this.state.officialReport);
    if (this.state.policeReportFile) {
      request.append("policeReport", this.state.policeReportFile);
    }

    axios
      .post(API + "/asset/assetflag", request, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState({
            msg:
              response.data.message ||
              "Asset flagged successfully! Law enforcement has been notified.",
            toastColor: "success",
            loading: false,
          });
          this.props.closeAction();
          if (this.props.onSuccess) {
            this.props.onSuccess();
          }
        } else {
          this.setState({
            msg: response.data.message || "Flagging failed",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            "Flagging failed. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return (
        <Modal title="Flag asset" footerContent={<></>}>
          <div className="w-full h-10 overflow-hidden flex justify-center items-center">
            <Spinner className="" />
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        title="Flag asset"
        closeAction={this.props.closeAction}
        footerContent={
          <>
            {s.valid && s.flagType && (
              <button
                type="button"
                className="btn btn-success disabled:cursor-not-allowed"
                disabled={!s.valid || !s.flagType}
                onClick={this.handleFlag}
              >
                Flag
              </button>
            )}
            <button
              type="button"
              className="btn btn-success"
              onClick={this.props.closeAction}
            >
              Close
            </button>
          </>
        }
      >
        {divMsg}
       <div className="row">
                         <div className="col">
                           <b>{primaryLabelName(s.assetType)}: </b>
                           <span>{s.assetBrand}</span>
                         </div>
                         <div className="col">
                           <b>{secondaryLabelName(s.assetType)}: </b>
                           <span>{s.assetModel}</span>
                         </div>
                       </div>
                       <div className="row">
                         <div className="col">
                           <b>{uniqueIdentifier1Name(s.assetType)}: </b>
                           <span>{s.assetUniqueIdentier}</span>
                         </div>
                       </div>
        <form
          className="flex flex-col w-full mt-2"
          autoComplete="off"
          onSubmit={this.handleFlag}
        >
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">Flag Type</label>
                <select
                  name="flagType"
                  className={`form-control ${
                    s.errors.flagType ? " !border-red-500" : ""
                  }`}
                  value={s.flagType}
                  onChange={this.handleChange}
                  required
                >
                  <option value="">Select</option>
                  {s.assetFlagDropdownList?.assetStatuss?.map((type) => (
                    <option key={`asset-status-${type}`} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
                {s.errors.flagType && (
                  <span className="input-group-error">{s.errors.flagType}</span>
                )}
              </div>
            </div>
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">Date</label>
                <input
                  name="date"
                  className={`form-control ${
                    s.errors.date ? " !border-red-500" : ""
                  }`}
                  type="date"
                  value={s.date}
                  onChange={this.handleChange}
                  required
                />
                {s.errors.date && (
                  <span className="input-group-error">{s.errors.date}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">
                  House / Building No & Street
                </label>
                <input
                  name="houseBuildingNo"
                  className={`form-control ${
                    s.errors.houseBuildingNo ? " !border-red-500" : ""
                  }`}
                  type="text"
                  value={s.houseBuildingNo}
                  onChange={this.handleChange}
                  placeholder="Enter house/building number and street"
                  required
                />
                {s.errors.houseBuildingNo && (
                  <span className="input-group-error">
                    {s.errors.houseBuildingNo}
                  </span>
                )}
              </div>
            </div>
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80 required">
                  Surburb
                </label>
                <input
                  type="text"
                  name="surburb"
                  value={s.surburb ? s.surburb : ""}
                  onChange={this.handleChange}
                  className={`form-control ${
                    s.errors.surburb ? " !border-red-500" : ""
                  }`}
                  required
                  list="surburbs"
                />
                <datalist id="surburbs">
                  {(s.assetFlagDropdownList?.surburbs || []).map((surb) => (
                    <option key={`surburb-option-${surb}`} value={surb}>
                      {surb}
                    </option>
                  ))}
                </datalist>
                {s.errors.surburb && (
                  <span className="input-group-error">{s.errors.surburb}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80 required">
                  Town/City
                </label>
                <Select
                  name="townCity"
                  value={(s.assetFlagDropdownList?.towns || []).filter(
                    ({ value }) => value === s.townCity
                  )}
                  onChange={(e) =>
                    this.handleSelect("townCity", e ? e.value : "")
                  }
                  className={`form-control ${
                    s.errors.townCity ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.assetFlagDropdownList?.towns || []}
                />
                {s.errors.townCity && (
                  <span className="input-group-error">{s.errors.townCity}</span>
                )}
              </div>
            </div>
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80 required">
                  Country
                </label>
                <Select
                  name="country"
                  value={(s.assetFlagDropdownList?.countries || []).filter(
                    ({ value }) => value === s.country
                  )}
                  onChange={(e) =>
                    this.handleSelect("country", e ? e.value : "")
                  }
                  className={`form-control ${
                    s.errors.country ? " !border-red-500" : ""
                  }`}
                  required
                  options={s.assetFlagDropdownList?.countries || []}
                />
                {s.errors.country && (
                  <span className="input-group-error">{s.errors.country}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="input-group">
                <label className="input-group-text !w-80">
                  Have you made an official police report?
                </label>
                <select
                  name="officialReport"
                  className={`form-control ${
                    s.errors.officialReport ? " !border-red-500" : ""
                  }`}
                  value={s.officialReport}
                  onChange={this.handleChange}
                  required
                >
                  <option value="">Select...</option>
                  <option value="NO">NO</option>
                  <option value="YES">YES</option>
                </select>
                {s.errors.officialReport && (
                  <span className="input-group-error">
                    {s.errors.officialReport}
                  </span>
                )}
              </div>
            </div>
            <div className="col">
              {s.officialReport === "YES" && (
                <div className="input-group">
                  <label className="input-group-text !w-80">
                    Police Report File
                  </label>
                  <input
                    name="policeReportFile"
                    className={`form-control ${
                      s.errors.policeReportFile ? " !border-red-500" : ""
                    }`}
                    type="file"
                    onChange={this.handleFileChange}
                    accept=".pdf,image/*"
                    required
                  />
                  {s.errors.policeReportFile && (
                    <span className="input-group-error">
                      {s.errors.policeReportFile}
                    </span>
                  )}
                </div>
              )}
            </div>
          </div>
        </form>
      </Modal>
    );
  }
}
